import React from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Valeurs de repli affichées avant la réponse du backend.
// LA SOURCE DE VÉRITÉ est le backend (GET /api/config) ; ne pas diverger ici.
export const DEFAULT_CONFIG = {
  platform_fee_percent: 15,
  guide_fee_percent: 85,
  payout_hold_days: 7,
  cancellation_fee_percent: 40,
  modification_fee_percent: 5,
  traveler_free_cancel_hours: 48,
  traveler_grace_hours: 24,
  host_last_minute_days: 7,
  max_group_size: 4,
  currency: 'jpy',
};

const ConfigContext = React.createContext(DEFAULT_CONFIG);

export function ConfigProvider({ children }) {
  const [config, setConfig] = React.useState(DEFAULT_CONFIG);

  React.useEffect(() => {
    axios
      .get(`${API_URL}/api/config`)
      .then((r) => setConfig({ ...DEFAULT_CONFIG, ...r.data }))
      .catch(() => {});
  }, []);

  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
}

export function useConfig() {
  return React.useContext(ConfigContext);
}
